export const UPLOAD_PROTOCOL = 'itsrapid-background-uploads-v1';
export const UPLOAD_WINDOW_URL = '/file/upload-window';
export const ACTIVE_UPLOAD_STATES = ['queued', 'preparing', 'uploading', 'processing'];

export const uploadContext = () => window.backgroundUploadContext;
export const uploadWindowName = () => `itsrapid-uploads-${uploadContext().userId}`;
export const uploadChannelName = () => `${UPLOAD_PROTOCOL}-${uploadContext().userId}`;

export function createUploadId() {
    return Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
}

export function uploadSummary(items) {
    const included = items.filter(item => item.status !== 'cancelled');
    const totalBytes = included.reduce((total, item) => total + item.size, 0);
    const loadedBytes = included.reduce((total, item) => total + Math.min(item.loaded, item.size), 0);

    return {
        active: included.filter(item => ACTIVE_UPLOAD_STATES.includes(item.status)).length,
        completed: included.filter(item => item.status === 'completed').length,
        failed: included.filter(item => item.status === 'failed').length,
        waiting: included.filter(item => item.status === 'duplicate').length,
        total: included.length,
        percent: totalBytes ? Math.floor(100 * loadedBytes / totalBytes) : 0,
    };
}
